import { environment } from '../../../environments/environment';

export class MosquittoConfig {
  // Valores directamente desde el environment (deben estar configurados)
  private static readonly hostname: string = environment.MOSQUITTO_HOST;
  private static readonly port: number //= environment.MOSQUITTO_PORT;
  private static readonly path: string = environment.MOSQUITTO_PATH || '/';
  // private static readonly protocol: 'wss' | 'ws' = environment.MOSQUITTO_PROTOCOL;
  private static readonly protocol: 'wss' | 'ws' =
    (typeof environment.MOSQUITTO_PROTOCOL === 'string' && (environment.MOSQUITTO_PROTOCOL === 'wss' || environment.MOSQUITTO_PROTOCOL === 'ws'))
      ? environment.MOSQUITTO_PROTOCOL as 'wss' | 'ws'
      : (window.location.protocol === 'https:' ? 'wss' : 'ws');
  private static readonly connectOnCreate: boolean = environment.MOSQUITTO_CONNECTION_ON_CREATE || true;


  // Métodos para obtener los valores (sin setters, son inmutables)
  public static getProtocol(): 'wss' | 'ws' {
    console.log('MosquittoConfig.getProtocol() called, returning:', MosquittoConfig.protocol);
    return MosquittoConfig.protocol;
  }

  public static getHostname(): string {
    return MosquittoConfig.hostname;
  }

  public static getPort(): number {
    console.log('MosquittoConfig.getPort() called, returning:', MosquittoConfig.port);
    return MosquittoConfig.port;
  }

  public static getPath(): string {
    return MosquittoConfig.path;
  }

  public static isConnectOnCreate(): boolean {
    return MosquittoConfig.connectOnCreate;
  }
}
